export enum HLHLContactRole {
  CashClose = "CashClose",
  CashCloseAdmin = "CashCloseAdmin",
  LoanManager = "LoanManager",
  LoanOfficer = "LoanOfficer",
  LoanOfficerAssistant = "LoanOfficerAssistant",
  LoanUnderwriter = "LoanUnderwriter",
  QualityControl = "QualityControl",
  SettlementAgent = "SettlementAgent",
  PostCloser = "PostCloser",
  CloserFunder = "CloserFunder",
}

export const HLHLContactRoleDisplayValues: { [key in HLHLContactRole]: string } = {
  [HLHLContactRole.CashCloseAdmin]: "Cash close admin",
  [HLHLContactRole.CashClose]: "Cash close",
  [HLHLContactRole.LoanManager]: "Loan manager",
  [HLHLContactRole.LoanOfficerAssistant]: "Mortgage advisor assistant",
  [HLHLContactRole.LoanOfficer]: "Loan officer",
  [HLHLContactRole.LoanUnderwriter]: "Underwriter",
  [HLHLContactRole.QualityControl]: "Quality control",
  [HLHLContactRole.SettlementAgent]: "Settlement agent",
  [HLHLContactRole.PostCloser]: "Post-closer",
  [HLHLContactRole.CloserFunder]: "Closer/funder",
};

export enum HLHLContactBranch {
  Denver = "Denver, Branch 242",
  Houston = "Houston, Branch 363",
  NewYork = "New York, Branch 100",
  SanFrancisco = "San Francisco, Branch 199",
  Scottsdale = "Scottsdale, Branch 137",
}

export const HLHLContactBranchDisplayValues: { [key in HLHLContactBranch]: string } = {
  [HLHLContactBranch.Denver]: "Denver",
  [HLHLContactBranch.Houston]: "Houston",
  [HLHLContactBranch.NewYork]: "NYC",
  [HLHLContactBranch.SanFrancisco]: "SF",
  [HLHLContactBranch.Scottsdale]: "Scottsdale",
};

export enum HLHLContactSource {
  EaveTeam = "EaveTeam",
}

export const HLHLContactSourceDisplayValues: { [key in HLHLContactSource]: string } = {
  [HLHLContactSource.EaveTeam]: "Eave",
};

export enum HLHLContactField {
  Id = "id",
  FirstName = "first_name",
  MiddleName = "middle_name",
  LastName = "last_name",
  Suffix = "suffix",
  PreferredFirstName = "preferred_first_name",
  Email = "email",
  Role = "role",
  Phone = "phone",
  Branch = "branch",
  Source = "source",
  NmlsId = "nmls_id",
  NmlsLicensedStates = "nmls_licensed_states",
  SlackId = "slack_id",
  DefaultSlackNotify = "default_slack_notify",
  SignatureImageUploadID = "signature_image_upload_id",
  SignatureImageS3Key = "signature_image_s3_key",
  HeadshotImageUploadID = "headshot_image_upload_id",
  HeadshotImageS3Key = "headshot_image_s3_key",
  Active = "active",
  CreatedAt = "created_at",
  UpdatedAt = "updated_at",

  // computed and set on front-end
  FullName = "full_name",
}

export interface HLHLContact {
  [HLHLContactField.Id]: number;
  [HLHLContactField.FirstName]: string;
  [HLHLContactField.MiddleName]: string | null;
  [HLHLContactField.LastName]: string;
  [HLHLContactField.Suffix]: string | null;
  [HLHLContactField.PreferredFirstName]: string | null;
  [HLHLContactField.Email]: string;
  [HLHLContactField.Role]: HLHLContactRole;
  [HLHLContactField.Phone]: string | null;
  [HLHLContactField.Branch]: HLHLContactBranch | null;
  [HLHLContactField.Source]: HLHLContactSource | null;
  [HLHLContactField.NmlsId]: string | null;
  [HLHLContactField.NmlsLicensedStates]: string | null;
  [HLHLContactField.SlackId]: string | null;
  [HLHLContactField.DefaultSlackNotify]: boolean;
  [HLHLContactField.SignatureImageUploadID]: number | null;
  [HLHLContactField.SignatureImageS3Key]: string | null;
  [HLHLContactField.HeadshotImageUploadID]: number | null;
  [HLHLContactField.HeadshotImageS3Key]: string | null;
  [HLHLContactField.Active]: boolean;
  [HLHLContactField.CreatedAt]: string;
  [HLHLContactField.UpdatedAt]: string;

  // computed and set on front-end
  [HLHLContactField.FullName]?: string;
}

export const HLHLContactFieldDisplayValues: { [key in HLHLContactField]: string } = {
  [HLHLContactField.Id]: "ID",
  [HLHLContactField.FirstName]: "First name",
  [HLHLContactField.MiddleName]: "Middle name",
  [HLHLContactField.LastName]: "Last name",
  [HLHLContactField.Suffix]: "Suffix",
  [HLHLContactField.PreferredFirstName]: "Preferred name",
  [HLHLContactField.Email]: "Email",
  [HLHLContactField.Role]: "Role",
  [HLHLContactField.Phone]: "Phone",
  [HLHLContactField.Branch]: "Branch",
  [HLHLContactField.Source]: "Source",
  [HLHLContactField.NmlsId]: "NMLS ID",
  [HLHLContactField.NmlsLicensedStates]: "NMLS licensed states",
  [HLHLContactField.SlackId]: "Slack ID",
  [HLHLContactField.DefaultSlackNotify]: "Notify loan channel",
  [HLHLContactField.SignatureImageUploadID]: "Signature image upload ID",
  [HLHLContactField.SignatureImageS3Key]: "Signature image S3 key",
  [HLHLContactField.HeadshotImageUploadID]: "Headshot image upload ID",
  [HLHLContactField.HeadshotImageS3Key]: "Headshot image S3 key",
  [HLHLContactField.Active]: "Active",
  [HLHLContactField.CreatedAt]: "Created at",
  [HLHLContactField.UpdatedAt]: "Last updated",

  // computed and set on front-end
  [HLHLContactField.FullName]: "Full name",
};
